import React from 'react';
import PageShell from '../components/page/PageShell';
import PageHeader from '../components/page/PageHeader';
import PageState from '../components/page/PageState';
import { useApp } from '../context/AppContext';
import QuestionBankCuratorConsole from '../components/questionBankCurator/QuestionBankCuratorConsole';
import { canCurateQuestionBank } from '../utils/questionBankCuratorModel';

/**
 * Question Bank Curator (Sheet 2 row 3). PRD s2.2: masters / config are platform_admin-only, and
 * every /admin/question-bank route is requireRole('platform_admin'). Gated here AND by the API; any
 * other persona gets no affordance and the console is never mounted, so no request is sent.
 *
 * AI-drafted questions follow Commandment IV (a human approves each one, then the version is
 * published) and published versions are immutable (Commandment VII).
 */
const QuestionBankCuratorPage = () => {
    const { user } = useApp();
    if (!canCurateQuestionBank(user?.role)) {
        return <PageState status="empty" message="The question bank curator is not available for your role." />;
    }
    return (
        <PageShell>
            <PageHeader title="Question Bank Curator" subtitle="Draft questions with AI from approved sources, review and approve them, and publish the next version of a standard's question bank" />
            <QuestionBankCuratorConsole />
        </PageShell>
    );
};

export default QuestionBankCuratorPage;
